import { Box, Button, Stack, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { MainContextState, MainContext } from "../../../../context/MainContext";
import { ReportTableCreator } from "./ReportTableCreator";
import { form4HeaderCells } from "../helpers/form4";
import { useFormContext } from "react-hook-form";

interface IProps {
    editForm?: boolean;
}

export const Form4EditForm = ({ editForm = false }: IProps) => {
    const { constants } = useContext<Partial<MainContextState>>(MainContext);
    const [fields, setFields] = useState<Array<number>>([0]);
    const { getValues } = useFormContext<any>();

    const isOwner =
        localStorage.getItem("employee_type") == "16" &&
        localStorage.getItem("employee_center_id") == localStorage.getItem("current_center_id");

    useEffect(() => {
        setFields(new Array(getValues("info.f4")?.length).fill(1));
    }, []);

    return (
        <>
            <Box sx={{ p: 2 }}>
                <Typography variant="h5" fontWeight={"bold"} textAlign={"left"}>
                    Форма 4
                </Typography>
            </Box>
            <ReportTableCreator
                bodyCell={fields.map((_item, index) => ({
                    col1: String(index + 1),
                    col2: { name: `info.f4.${index}.0` },
                    col3: { name: `info.f4.${index}.1` },
                    col4: { name: `info.f4.${index}.2` },
                    col5: { name: `info.f4.${index}.3`, numeric: true },
                    col6: { name: `info.f4.${index}.4`, fileList: true },
                }))}
                headerCell={form4HeaderCells}
            />
            {/* <Stack direction={"row"} gap={2}> */}
            <Button
                onClick={() => {
                    setFields(prev => [...prev, 1]);
                }}>
                Добавить строку
            </Button>
            {/* <Button
                    onClick={() => {
                        setFields(prev => {
                            const tmp = [...prev];
                            tmp.pop();
                            return tmp;
                        });
                    }}>
                    Удалить строку
                </Button> */}
            {/* </Stack> */}
        </>
    );
};
